export const languages = [
  {
    Id: 1398,
    Locale: "en-GB",
    Value: "English",
  },
  {
    Id: 1399,
    Locale: "de-DE",
    Value: "Deutsche",
  },
  {
    Id: 1401,
    Locale: "es-ES",
    Value: "Español",
  },
  {
    Id: 1402,
    Locale: "fr-FR",
    Value: "Francés",
  },
  {
    Id: 1407,
    Locale: "pt-PT",
    Value: "Português",
  },
  {
    Id: 1410,
    Locale: "zh-CN",
    Value: "中文",
  },
  {
    Id: 1411,
    Locale: "ko-KR",
    Value: "한국어",
  },
  {
    Id: 1412,
    Locale: "ja-JP",
    Value: "日本語",
  },
  // {
  //   Id: 1413,
  //   Locale: "ar-SA",
  //   Value: "العربية",
  // },
  {
    Id: 1414,
    Locale: "zh-TW",
    Value: "Chinese (Traditional, Taiwan)",
  },
];
